<template>
  <article class="space-y-[18px]">
    <DocumentBlock v-for="(node, i) in document?.content ?? []" :key="node.attrs?.id ?? i" :node="node" />
  </article>
</template>

<script setup>
import DocumentBlock from '@/components/writer/reader/DocumentBlock.vue';

/** A page document as HTML. The iPhone draws the same JSON with its own SwiftUI views. */
defineProps({ document: { type: Object, default: null } });
</script>
